module.exports = __webpack_public_path__ + "assets/bf5c5c26a55c3859f38b42d81b00961c.png";